import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if it exists
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', { email, password });
    return response.data;
  },

  signup: async (email, password, full_name) => {
    const response = await apiClient.post('/auth/signup', {
      email,
      password,
      full_name,
    });
    return response.data;
  },

  getCurrentUser: async (token) => {
    const response = await apiClient.get('/auth/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
};

// H3 Analysis API
export const h3API = {
  analyzeLocation: async (latitude, longitude, resolution = 11) => {
    const response = await apiClient.post('/h3/analyze', {
      latitude,
      longitude,
      resolution,
    });
    return response.data;
  },

  getHexData: async (hexId) => {
    const response = await apiClient.get(`/h3/hex/${hexId}`);
    return response.data;
  },
};

// Postcode API (to be implemented)
export const postcodeAPI = {
  getSectorsByHex: async (hexId) => {
    const response = await apiClient.get(`/postcode/sectors/${hexId}`);
    return response.data;
  },
};

// Origins API
export const originsAPI = {
  getHexOrigins: async (hex11Id) => {
    const response = await apiClient.get(`/origins/origins/${hex11Id}`);
    return response.data;
  },

  getPostcodeDestinations: async (postcodeSector) => {
    const response = await apiClient.get(`/origins/destinations/${encodeURIComponent(postcodeSector)}`);
    return response.data;
  },

  getHex5PlaceNames: async (hex5Ids) => {
    const response = await apiClient.post('/origins/hex5-place-names', hex5Ids);
    return response.data;
  },

  getHex6PlaceNames: async (hex6Ids) => {
    const response = await apiClient.post('/origins/hex6-place-names', hex6Ids);
    return response.data;
  },
};

// Saved Analyses API
export const savedAnalysesAPI = {
  save: async (analysisData) => {
    const response = await apiClient.post('/analyses/save', analysisData);
    return response.data;
  },

  list: async () => {
    const response = await apiClient.get('/analyses/list');
    return response.data;
  },

  load: async (analysisId) => {
    const response = await apiClient.get(`/analyses/load/${analysisId}`);
    return response.data;
  },

  delete: async (analysisId) => {
    const response = await apiClient.delete(`/analyses/delete/${analysisId}`);
    return response.data;
  },
};

// Brands API
export const brandsAPI = {
  list: async () => {
    const response = await apiClient.get('/brands/list');
    return response.data;
  },

  getCategories: async () => {
    const response = await apiClient.get('/brands/categories');
    return response.data;
  },

  getPOIs: async (brandId) => {
    const response = await apiClient.get(`/brands/pois/${brandId}`);
    return response.data;
  },
};

export default apiClient;
